export default {
	body_bg: '#F0F0F7',
	lighter_gray: '#F2F2F2',
	light_gray: '#cccccc',
	gray: '#949494',
	dark_gray: '#707070',
	darker_gray: '#4D4F5C',
	blue: '#0083BF',
	dark_blue: '#26337B',
	darker_blue: '#43425D',
	indigo: '#6574cd',
	purple: '#9561e2',
	pink: '#f66d9b',
	red: '#e3342f',
	orange: '#F05423',
	yellow: '#ffed4a',
	green: '#009D66',
	teal: '#4dc0b5',
	cyan: '#6cb2eb',
	bootstrap_success: '#5cb85c',
	bootstrap_danger: '#d9534f',
	bootstrap_info: '#5bc0de'
};
